import React from "react";
import { Typography, Grid, Box, useMediaQuery, useTheme } from "@mui/material";
import companyImage from "./aboutus.jpg";
import vmvImage from "../../assets/Gallery/img6.jpeg";
import customerCommitment from "../../assets/about/customer-commitment.png";
import quality from "../../assets/about/quality.png";
import integrity from "../../assets/about/integrity.png";
import teamWork from "../../assets/about/team-work.png";
import respectForPeople from "../../assets/about/respect-for-people.png";
import { ProjectCard } from "../Projects/ProjectCard";
import { Carousel } from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";
import { getImageUrl } from "../../utils";
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap CSS is included

const DetailedAboutUs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box p={5} paddingLeft={"10%"} paddingRight={"10%"}>
      {/* Company Details */}
      <Grid
        container
        spacing={isMobile ? 2 : 3}
        alignItems="center"
        flexDirection={"row"}
        gap={"2.5rem"}
        wrap={isMobile ? "wrap" : "noWrap"}
      >
        <Grid item xs={12} md={6}>
          <img
            src={companyImage}
            alt="Company"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </Grid>
        <Grid
          display={"flex"}
          flexDirection={"column"}
          alignItems={"start"}
          xs={12}
          md={6}
        >
          <Typography
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
            variant="h4"
            gutterBottom
          >
            About Our Company
          </Typography>
          <Typography>
            <b>Adarsh Industries</b> is a leading cattle feed manufacturer with
            a rich history dating back to June 1990. For nearly <b>35 years</b>,
            we have been dedicated to providing the highest quality cattle feed
            products to farmers and their livestock. Our commitment to
            excellence has made us a trusted name in the industry.
          </Typography>
          <Typography>
            We understand that healthy cattle are essential for the success of
            farmers. That's why we strive to create premium cattle feed
            solutions that not only nourish but also enhance the well-being of
            your animals. Our products are formulated with the utmost care,
            using only the finest ingredients to ensure optimal nutrition and
            growth.
          </Typography>
          <Typography>
            At Adarsh Industries, we believe in offering affordable products
            without compromising on quality. Our aim is to make nutritious
            cattle feed accessible to all farmers, empowering them to achieve
            their goals.
          </Typography>
          <Typography>
            Join the thousands of satisfied customers who have experienced the
            benefits of Adarsh Industries cattle feed. Discover why we are the
            preferred choice for farmers across the region.
          </Typography>
        </Grid>
      </Grid>

      <Grid
        marginTop={10}
        container
        spacing={isMobile ? 2 : 3}
        alignItems="center"
        style={{
          marginTop: "20px",
        }}
      >
        <Grid
          display={"flex"}
          flexDirection={"column"}
          alignItems={"start"}
          xs={12}
          md={6}
        >
          <Box my={4}>
            <Typography variant="h4" gutterBottom textAlign={"center"}>
              Vision
            </Typography>
            <Typography>
              To be the most trusted and innovative provider of premium cattle
              feed, enhancing the health and productivity of livestock, while
              empowering farmers to achieve sustainable growth and success.
            </Typography>
          </Box>

          {/* Mission */}
          <Box my={4}>
            <Typography variant="h4" gutterBottom textAlign={"center"}>
              Mission
            </Typography>
            <Typography>
              At Adarsh Industries, we are committed to producing high-quality,
              affordable cattle feed solutions that nourish livestock and
              support farmers in optimizing animal health and productivity.
              Through innovation, integrity, and a passion for excellence, we
              strive to make nutritious cattle feed accessible to all farmers,
              fostering long-term success in agriculture.
            </Typography>
          </Box>

          {/* Values */}
        </Grid>

        {!isMobile && (
          <Grid item xs={12} md={6}>
            <img
              src={vmvImage}
              alt="Company"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </Grid>
        )}
      </Grid>

      <Grid
        marginTop={10}
        container
        spacing={isMobile ? 2 : 3}
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <Grid>
          <Box
            style={{
              backgroundColor: "#4caf50",
              color: "white",
              borderRadius: "1rem",
              textAlign: "center",
            }}
            my={4}
            padding={5}
            display={"flex"}
            flexDirection={"column"}
            gap={5}
          >
            <Typography variant="h4" gutterBottom>
              Values
            </Typography>
            <Carousel indicators={false} interval={null}>
              <Carousel.Item>
                {[
                  {
                    title: "Customer Commitment",
                    description:
                      "We develop relationships that make a positive difference in our customer's lives.",
                    image: customerCommitment,
                  },
                  {
                    title: "Nutrition Guarantee",
                    description:
                      "Our cattle feed is formulated by expert nutritionists to ensure optimal health and productivity for your livestock, guaranteed.",
                    image: quality,
                  },
                ].map((item, index) => {
                  return (
                    <Container key={index}>
                      <Row>
                        <Col md={6}>
                          <img
                            src={item.image}
                            alt={item.title}
                            className="img-fluid"
                          />
                        </Col>
                        <Col md={6}>
                          <div>
                            <h2>{item.title}</h2>
                            <p>{item.description}</p>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  );
                })}
              </Carousel.Item>
              <Carousel.Item>
                {[
                  {
                    title: "Integrity",
                    description:
                      "We hold the highest standards of Integrity in all of our actions.",
                    image: integrity,
                  },
                  {
                    title: "Team Work",
                    description:
                      "We work together, across boundaries, to meet the needs of our customers and to help the company win.",
                    image: teamWork,
                  },
                ].map((item, index) => {
                  return (
                    <Container key={index}>
                      <Row>
                        <Col md={6}>
                          <img
                            src={item.image}
                            alt={item.title}
                            className="img-fluid"
                          />
                        </Col>
                        <Col md={6}>
                          <div>
                            <h2>{item.title}</h2>
                            <p>{item.description}</p>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  );
                })}
              </Carousel.Item>
              <Carousel.Item>
                {[
                  {
                    title: "Team Work",
                    description:
                      "We work together, across boundaries, to meet the needs of our customers and to help the company win.",
                    image: teamWork,
                  },
                  {
                    title: "Respect For People",
                    description:
                      "We value our people, encourage their development, and reward their performance.",
                    image: respectForPeople,
                  },
                ].map((item, index) => {
                  return (
                    <Container key={index}>
                      <Row>
                        <Col md={6}>
                          <img
                            src={item.image}
                            alt={item.title}
                            className="img-fluid"
                          />
                        </Col>
                        <Col md={6}>
                          <div>
                            <h2>{item.title}</h2>
                            <p>{item.description}</p>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  );
                })}
              </Carousel.Item>
            </Carousel>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DetailedAboutUs;
